import { jsxs as l, jsx as r } from "react/jsx-runtime";
import { c as g } from "../../index-Cu0xwYjD.js";
import { forwardRef as q, useContext as y } from "react";
import { propagateTestid as p } from "../../utils/helpers.js";
import { useIdIfNeeded as j } from "../../utils/hooks/useIdIfNeeded.js";
import { RadioGroupContext as B } from "../RadioGroup/RadioGroupContext.js";
const F = "ids-radio-v501", G = "ids-radio--input-v501", H = "ids-radio--label-v501", I = "ids-radio--hidden-control-v501", M = "ids-radio--mark-v501", i = {
  radio: F,
  input: G,
  label: H,
  hiddenControl: I,
  mark: M
}, S = () => /* @__PURE__ */ r(
  "svg",
  {
    version: "1.1",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    className: i.mark,
    children: /* @__PURE__ */ r("circle", { cx: "100", cy: "100", r: "70" })
  }
), z = ({
  checked: u,
  children: h,
  className: f,
  "data-testid": d,
  hiddenControl: v,
  name: k,
  onChange: s,
  required: x,
  value: t,
  ...e
}, R) => {
  const a = j(e), o = y(B), N = !!o.onChange, w = o.name ?? k, n = o.hiddenRadio ?? v, b = N ? o.value === t : u, C = o.required ?? x;
  return /* @__PURE__ */ l(
    "div",
    {
      "data-testid": d,
      className: g(f, {
        [i.radio]: !0,
        [i.hiddenControl]: n
      }),
      children: [
        /* @__PURE__ */ r(
          "input",
          {
            ...e,
            type: "radio",
            id: a,
            name: w,
            ref: R,
            className: i.input,
            "data-testid": p(d, "input"),
            onChange: (c) => {
              var m;
              s == null || s(c, t), (m = o.onChange) == null || m.call(o, c, t);
            },
            value: String(t),
            checked: b,
            required: C
          }
        ),
        /* @__PURE__ */ l("label", { htmlFor: a, className: i.label, children: [
          !n && /* @__PURE__ */ r(S, { "data-testid": p(d, "mark") }),
          h
        ] })
      ]
    }
  );
}, O = q(z);
export {
  O as IressRadio
};
